import React from 'react'
import classnames from 'classnames'

export interface ContentImageProps {
    bgSrc?: string
    fgSrc: string
    className?: string
    containerClassName?: string
}

export const ContentImage: React.FC<ContentImageProps> = ({
    bgSrc,
    fgSrc,
    className,
    containerClassName,
}) => (
    <div
        data-testid="content-image"
        className={classnames(
            'relative flex h-[320px] h-full w-full items-center justify-center sm:h-[504px]',
            containerClassName
        )}
    >
        {bgSrc && (
            <img
                src={bgSrc}
                alt=""
                className="absolute inset-0 z-0 h-full w-full object-cover"
                draggable={false}
            />
        )}
        <img
            src={fgSrc}
            alt="Sustainability foreground"
            className={classnames(
                'relative z-10 h-full object-contain',
                className
            )}
            draggable={false}
        />
    </div>
)
